import { publicHref } from '../lib/publicUrls';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import MediaTruthSurface from '../components/MediaTruthSurface';
import { MEDIA_SLOTS } from '../lib/mediaTruth';
import { ServiceBreadcrumb, ServiceFacts } from '../components/ServiceHeader';
import ProgramsJourney from '../components/ProgramsJourney';
import { TourClosing } from '../components/TourJourney';
import './ProgramsPage.css';

const ProgramsPage = () => (
  <main className="dv-programs" data-testid="programs-page">
    <SEO
      title="Fitness Programs | Delta Valley Health Club Brentwood"
      description="Explore personal training, MX4, Reformer Pilates, aquatics, kids and family programs, and massage at Delta Valley Health Club."
      keywords="fitness programs Brentwood CA, personal training, swimming, reformer Pilates, MX4, massage"
    />

    <section className="dv-programs__hero" aria-labelledby="programs-title">
      <MediaTruthSurface
        media={MEDIA_SLOTS.programsOverviewHero}
        className="dv-programs__hero-media"
        decorative
      />
      <div className="dv-programs__hero-veil" aria-hidden="true" />
      <div className="dv-programs__hero-copy">
        <div className="dv-service-panel">
          <ServiceBreadcrumb parent={{ label: 'Home', href: '/' }} current="Programs" />
          <h1 id="programs-title" className="dv-size-heading dv-service-title dv-programs__hero-title" aria-label="Commit to Fit!">
            <span>Commit</span>
            <em>to Fit!</em>
          </h1>
          <p className="dv-size-lede dv-programs__hero-introduction">
            A program for every experience level and goal.
          </p>
          <div className="dv-service-actions dv-programs__hero-actions">
            <a className="dv-button dv-button--light" href="#all-programs">Explore All Programs</a>
            <Link className="dv-button dv-button--outline-light" to={publicHref("/book-a-tour")}>Book a Tour</Link>
          </div>
        </div>
      </div>
      <ServiceFacts items={["Eight programs", "Every experience level and goal", "Heated indoor pools, year-round"]} />
    </section>

    <ProgramsJourney />

    <TourClosing />
  </main>
);

export default ProgramsPage;
